import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import Routes from '../../config/routes';
import { useAuthContext } from '../../hooks/useAuth/useAuthContext';

function SceneManager({ routes, ...props }: {
  routes: typeof Routes;
}) {
  const { isAuthenticated } = useAuthContext();

  const loginRedirect = (
    <Navigate
      to={'/login'}
      replace
    />
  );

  return (
    <Router>
      <RouterRoutes {...props}>
        {
          Object.values(routes)
            .map(
              (route) => {
                const loginRequired = route.requiresAuth && !isAuthenticated;

                const element = loginRequired
                  ? loginRedirect
                  : route.element;

                return (
                  <Route
                    key={route.id}
                    path={route.path}
                    element={element}
                  />
                );
              },
            )
        }
      </RouterRoutes>
    </Router>
  );
}

export default SceneManager;
